import { EditorState, SelectionState, Modifier } from 'draft-js';

// Adopted from https://github.com/ngs/draft-js-markdown-shortcuts-plugin.

const inlineMatchers = {
    BOLD: [
        /\B\*\*([^(?:**)]+)\*\*\B/g,
        /\b__([^(?:__)]+)__\b/g,
    ],
    ITALIC: [
        /\B\*([^(?:*)]+)\*\B/g,
        /\b_([^(?:_)]+)_\b/g,
    ],
    STRIKETHROUGH: [
        /\B~~([^(?:~~)]+)~~\B/g,
    ],
    HIGHLIGHT: [
        /\B==([^(?:==)]+)==\B/g,
    ],
    CODE: [
        /\B`([^(?`)]+)`\B/g,
    ],
};

const changeCurrentInlineStyle = (editorState, matchArr, style) => {
    const currentContent = editorState.getCurrentContent();
    const selection = editorState.getSelection();
    const key = selection.getStartKey();
    const { index } = matchArr;
    const blockMap = currentContent.getBlockMap();
    const block = blockMap.get(key);
    const currentInlineStyle = block.getInlineStyleAt(index).merge();
    const newStyle = currentInlineStyle.merge([style]);
    const focusOffset = index + matchArr[0].length;
    const wordSelection = SelectionState.createEmpty(key).merge({
        anchorOffset: index,
        focusOffset,
    });

    let newContentState = Modifier.replaceText(
        currentContent,
        wordSelection,
        matchArr[1],
        newStyle,
    );

    // this determines the new selection by comparing the length of the old block
    // with the length of the new
    const textDiff = newContentState.getBlockForKey(key).getText().length - block.getText().length;
    const anchorOffset = selection.getAnchorOffset() + textDiff;

    newContentState = Modifier.insertText(
        newContentState,
        selection.merge({
            anchorOffset,
            focusOffset: anchorOffset,
        }),
        '',
    );

    const newEditorState = EditorState.push(
        editorState,
        newContentState,
        'change-inline-style',
    );

    return EditorState.forceSelection(newEditorState, newContentState.getSelectionAfter());
};

const handleInlineStyle = (editorState, _character) => {
    const character = _character === 'Enter' ? ' ' : _character;
    let newEditorState = editorState;
    const selectionState = editorState.getSelection();
    const anchorKey = selectionState.getAnchorKey();
    const currentContentBlock = editorState.getCurrentContent().getBlockForKey(anchorKey);
    const end = selectionState.getEndOffset();

    const text = currentContentBlock.getText().slice(0, end);
    const line = `${text}${character}`;

    Object.keys(inlineMatchers).some((k) => {
        inlineMatchers[k].some((re) => {
            let matchArr;
            do {
                matchArr = re.exec(line);
                if (matchArr) {
                    const position = matchArr.index + matchArr[0].length;
                    const anchorOffset = selectionState.getAnchorOffset() - 1;
                    if (position === anchorOffset) {
                        newEditorState = changeCurrentInlineStyle(newEditorState, matchArr, k);
                    }
                }
            } while (matchArr);
            return newEditorState !== editorState;
        });
        return newEditorState !== editorState;
    });
    return newEditorState;
};

export default handleInlineStyle;
